import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const ConnectingContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxl} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid ${({ theme }) => theme.colors.background};
  border-top: 5px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1.5s linear infinite;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Connecting: React.FC = () => {
  useEffect(() => {
    // 여기에 필요한 연결 로직을 추가할 수 있습니다
    const connectionTimeout = setTimeout(() => {
      // 연결 시간 초과 처리 로직
    }, 30000); // 30초 타임아웃

    return () => {
      clearTimeout(connectionTimeout);
    };
  }, []);

  return (
    <ConnectingContainer>
      <LoadingSpinner />
      <Title>연결 중...</Title>
      <Description>
        서버와 연결 중입니다. 잠시만 기다려 주세요.
      </Description>
    </ConnectingContainer>
  );
};

export default Connecting;